import { createFileRoute } from '@tanstack/react-router'
import { nnppDocumentKindSchema } from 'types/nnpp/imports/nnppImportSchemas'
import { z } from 'zod'

import { NnppImportsPage } from '@/src/pages/nnpp/imports/NnppImportsPage'

export const nnppImportsSearchSchema = z.object({
  kind: nnppDocumentKindSchema.optional().catch(undefined),
})

export const Route = createFileRoute('/nnpp/imports/')({
  component: NnppImportsPage,
  validateSearch: nnppImportsSearchSchema,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
